import { Component } from '@angular/core';
import { filter, map } from 'rxjs';
import { Target } from '../../../interfaces/pratica';
import { IconService } from '../../_core/services/icon.service';
import { PersonaGiuridicaService } from '../../_core/services/persona-giuridica.service';
import { PraticaProgressService } from '../../_core/services/pratica-progress.service';
import { SharedModule } from '../../_shared/shared.module';

@Component({
  selector: 'app-pratica-title',
  templateUrl: './pratica-title.component.html',
  styleUrls: ['./pratica-title.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class PraticaTitleComponent {
  constructor(
    public praticaProgressService: PraticaProgressService,
    public pgService: PersonaGiuridicaService,
    iconService: IconService
  ) {
    iconService.getIcons(['businesses', 'professionals']);
  }

  get logo() {
    return this.praticaProgressService.selectedPratica$.pipe(
      filter((praticaData) => praticaData.state === 'completed'),
      map((praticaData) =>
        praticaData.data?.target === Target.IMPRESE
          ? 'businesses'
          : 'professionals'
      )
    );
  }
}
